import React from "react";
import { find } from "lodash";
import { css } from "react-emotion";
import { flexColumn } from "appStyles";

import { TemplateComponent } from "components";
import { withRedux } from "helpers";

const container = css`
  ${flexColumn}
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 15px;

  * {
    margin-bottom: 5px;
  }
  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

const PictureCatalog = (props) => {
  const { activeTemplate } = props;

  const catalog = find(activeTemplate.components, { componentNumber: 1 });

  return (
    <div>
      <TemplateComponent {...catalog} />
    </div>
  );
};

export default withRedux(PictureCatalog);
